export class Domain {
  id: string;
  titleShort: string;

  constructor(data = {}) {
    this.id = data['id'];
    this.titleShort = data['titleShort'];
  }
}
